import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import { transformProduct } from "~/features/productDetails/transformers/ProductDataTransformer";
import type { ProductData } from "~/domains/product/types/ProductData";
import { type RelatedProductListResponseDTO, toProductDataDTO } from "./relatedProductDTO";

export async function fetchRelatedProducts(productCode: string): Promise<ProductData[]> {
  const url = occUrl(`/p/${productCode}/related`);

  const response = await occFetch(url);
  if (response.ok) {
    const data = ((await response.json()) as RelatedProductListResponseDTO).items ?? [];
    return data.map((product) => transformProduct(toProductDataDTO(product)));
  }
  throw new Error("Error fetching data");
}
